

    if (window.innerWidth < 1150) {
        document.querySelectorAll('.facets__panel').forEach(open => {
        open.removeAttribute('open');
        });
    }

    document.querySelectorAll(".custom-add-to-cart").forEach(function (btn) {
        btn.addEventListener("click", function () {
            var moveout = false;
            document.querySelectorAll(".custom-field [required]").forEach(function (input) {
                if (input.value == "") {
                    moveout = true;
                }
            })

            if (moveout) {
                alert("Please fill all required fields");
                return;
            } 

            var items = [];

            var addcart = false;

            document.querySelectorAll(".price-sensitive").forEach(function (div) {
                var selectOptions = div.querySelectorAll("select option");
                var select = div.querySelector("select");
                selectOptions.forEach(function (option) {
                    if (option.getAttribute("value") == select.value) {
                        if (option.getAttribute("data-id") != "" && option.getAttribute("data-id") != null) {
                            addcart = true;
                            items.push({
                                id: parseInt(option.getAttribute("data-id")),
                                quantity: 1
                            })
                        }
                    }
                })
            })

            console.log(addcart)

            if (addcart) {
                jQuery.post('/cart/add.js', {
                    items: items
                }).done(function () {
                    if(document.querySelector("add-to-cart-component button")){
                        document.querySelector("add-to-cart-component button").click()
                    }
                    if(document.getElementById("appointo-btn")){
                        document.getElementById("appointo-btn").click()
                    }
                });
            } else {

                if(document.querySelector("add-to-cart-component button")){
                    document.querySelector("add-to-cart-component button").click()
                }
                if(document.getElementById("appointo-btn")){
                    document.getElementById("appointo-btn").click()
                }
            }


        })
    })


    document.querySelectorAll(".price-sensitive select").forEach(function (select) {
        select.addEventListener("change", function () {
            var price = parseInt(document.querySelector(".price-sensitive select") ? document.querySelector(".price-sensitive select").getAttribute("data-main-price"): 0);
            document.querySelectorAll(".price-sensitive").forEach(function (div) {
                var selectOptions = div.querySelectorAll("select option");
                var select = div.querySelector("select");
                selectOptions.forEach(function (option) {
                    if (option.getAttribute("value") == select.value) {
                        if (option.getAttribute("data-id") != "") {
                            price = price + parseInt(option.getAttribute("data-price"));
                        }
                    }
                })
            })



            var baseAmount = parseFloat(price * 0.01);
            var shopCurrency = Shopify.currency.active || Shopify.shop_currency || 'GBP';
            var rate = Shopify.currency.rate || 0.01; // fallback if no rate

            // Convert manually if needed (assume base is INR)
            var converted = baseAmount * rate;

            var totalPrice = new Intl.NumberFormat(undefined, {
                style: "currency",
                currency: shopCurrency,
                minimumFractionDigits: 2,
            }).format(baseAmount);

            document.querySelector(".price-item.price-item--regular")
            ? document.querySelector(".price-item.price-item--regular").textContent = totalPrice + ' ' + shopCurrency
            : "";
        })
    })

    document.querySelectorAll('.top_menus label').forEach(label => {
        label.addEventListener('click', function () {
        // agar current label already active hai
        if (this.classList.contains('active')) {
            this.classList.remove('active'); 
        } else {
            // sabse phele sabhi labels se active remove
            document.querySelectorAll('.top_menus label').forEach(l => l.classList.remove('active'));
            // fir current par active lagao
            this.classList.add('active');
        }
        });
    });

    document.querySelector('.manu-wrapper')
    ? document.querySelector('.manu-wrapper').addEventListener('mouseleave', function() {
        document.querySelectorAll('.top_menus label').forEach(label => {
        label.classList.remove('active'); 
        label.querySelector('input') ? label.querySelector('input').checked = false: "";
        });
    }):
    "";

